import { createContext, useContext, useReducer } from 'react';

import type {
    IAppContext,
    IState,
    TAction,
} from '@/frontend/src/types/context';

import { reducer } from './reducer';
import { initialState } from './initialState';

const AppContext = createContext<{
    state: IState;
    dispatch: React.Dispatch<TAction>;
}>({
    state: initialState,
    dispatch: () => undefined,
});

const computeInitialState = ({
    context,
    parentApp,
    geo,
    portal,
    ctaButtonInfo,
    mobileBreakpoint,
    tracking,
}: IAppContext) => {
    return {
        ...initialState,
        context,
        parentApp,
        geo,
        portal,
        ctaButtonInfo,
        mobileBreakpoint,
        tracking,
    };
};

const useAppContext = () => useContext(AppContext).state;
const useAppDispatch = () => useContext(AppContext).dispatch;

const AppProvider = ({
    context,
    parentApp,
    geo,
    portal,
    ctaButtonInfo,
    children,
    mobileBreakpoint,
    tracking,
}: IAppContext) => {
    const [state, dispatch] = useReducer(
        reducer,
        computeInitialState({
            context,
            parentApp,
            geo,
            portal,
            ctaButtonInfo,
            mobileBreakpoint,
            tracking,
        }),
    );

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppProvider, useAppContext, useAppDispatch };
